__turbopack_context__.v({
  "content": "TaxReceiptHint-module__W8u9Qq__content",
  "learnMoreLink": "TaxReceiptHint-module__W8u9Qq__learnMoreLink",
  "taxReceiptHint": "TaxReceiptHint-module__W8u9Qq__taxReceiptHint",
});
